module.exports = __webpack_public_path__ + "img/team__info.423ad361.png";